import type { RouteLocationNormalized } from 'vue-router';

const RELOAD_FLAG_KEY = 'addviseo:chunk-reload-attempted';

const CHUNK_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'error loading dynamically imported module',
];

const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  return CHUNK_ERROR_PATTERNS.some((pattern) => error.message.includes(pattern));
};

export type ChunkErrorHandlerDeps = {
  storage?: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
  reload?: (url: string) => void;
};

export const handleChunkLoadError = (
  error: unknown,
  to: RouteLocationNormalized | undefined,
  { storage, reload }: ChunkErrorHandlerDeps = {},
): boolean => {
  if (!isChunkLoadError(error)) return false;

  const storageImpl = storage ?? window.sessionStorage;
  const reloadImpl = reload ?? ((url: string) => window.location.assign(url));
  const targetPath = to?.fullPath ?? window.location.pathname + window.location.search;

  if (storageImpl.getItem(RELOAD_FLAG_KEY) === targetPath) {
    storageImpl.removeItem(RELOAD_FLAG_KEY);
    return false;
  }

  storageImpl.setItem(RELOAD_FLAG_KEY, targetPath);
  reloadImpl(targetPath);
  return true;
};

export const clearChunkReloadFlag = (
  storage: Pick<Storage, 'removeItem'> = window.sessionStorage,
): void => {
  storage.removeItem(RELOAD_FLAG_KEY);
};
